import React from 'react';
import classNames from 'classnames';
import { BodyText, Text } from '@gje/typography/lib';
import posed, { PoseGroup } from 'react-pose';
import Pair from '../../../../types/Pair';
import useScroll from '../../../../hooks/useScroll';
import useNextRenderCall from '../../../../hooks/useNextRenderCall';
import { HtmlPanel } from '../../HtmlPanel/HtmlPanel';
import {
    isOkq8,
    isVillaagarna
} from '../../../../services/partners/partnersService';

interface DirectPaymentFieldProps {
    isOpen: boolean;
    onClick: Function;
    data: Pair<string, string>;
}

const blueQuestionMark = require('../../../../images/blue-questionmark.png');

const MoreInfo = posed.div({
    exit: {
        height: 0,
        opacity: 0,
        transition: {
            ease: 'easeIn',
            duration: 0
        }
    },
    enter: {
        opacity: 1,
        height: 'auto',
        transition: {
            ease: 'easeIn',
            duration: 300
        }
    }
});

const DirectPaymentField: React.FC<DirectPaymentFieldProps> = ({
    isOpen,
    onClick,
    data
}) => {
    const { scroll, ScrollTo } = useScroll();
    const smoothScroll = useNextRenderCall(scroll);

    const handleCoverHelpClick = () => {
        onClick();
        if (!isOpen) {
            smoothScroll();
        }
    };

    return (
        <ScrollTo>
            <div key={data.key} className={'margin-bottom-8'}>
                <a
                    className={classNames('direct-payment-header', {
                        'okq8-grey-label-not-bold': isOkq8()
                    })}
                    onClick={() => handleCoverHelpClick()}>
                    <div className={'display-inline-flex align-items'}>
                        {isOkq8() ? (
                            <img
                                className={classNames(
                                    'position-inherit',
                                    'direct-payment-help-icon-margin'
                                )}
                                src={blueQuestionMark}
                                alt="blueQM"
                            />
                        ) : (
                            <span
                                className={classNames(
                                    'gj-icon',
                                    'gj-icon-help-open',
                                    'position-inherit',
                                    'direct-payment-help-icon-margin'
                                )}
                            />
                        )}
                        <Text
                            size={'h6'}
                            className={classNames({
                                'font-size-16': isVillaagarna()
                            })}>
                            {data.key}
                        </Text>
                    </div>
                </a>
                <div className="mobile-extra-coverages-list-element padding-left-2">
                    <PoseGroup>
                        {isOpen && [
                            <MoreInfo
                                className={classNames('direct-payment-field')}
                                key="moreInfoHelpBox">
                                <BodyText
                                    className={classNames(
                                        'font-size-15',
                                        'margin-bottom-16',
                                        'max-width-500',
                                        { 'okq8-grey-label-not-bold': isOkq8() }
                                    )}>
                                    <HtmlPanel>{data.value}</HtmlPanel>
                                </BodyText>
                            </MoreInfo>
                        ]}
                    </PoseGroup>
                </div>
            </div>
        </ScrollTo>
    );
};

export default DirectPaymentField;
